<template>
    <div id="app">
        <router-view v-if="isWechat"></router-view>
        <div v-else class="wechat-tip">请在微信中打开此页面</div>
    </div>
</template>

<script>

export default {
    name: 'App',
    data() {
        return { isWechat: false };
    },
    created() {
        this.isWechat = true
       // navigator.userAgent.toLowerCase().includes('micromessenger') ? this.isWechat = true : this.isWechat = false;
    }
};
</script>

<style lang="less">
@import './styles/common.less';

#app {
    text-align: left;
    height: 100%;
}

.robot-avatar {
    width: 32px;
    height: 32px;
    margin-top: 5px;
    border-radius: 32px;
    vertical-align: middle;
    margin-right: 10px;
}

html,
body {
    margin: 0;
    height: 100%;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Microsoft YaHei", "Noto Sans", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

a {
    color: var(--color-primary-normal);
}

.wechat-tip {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #333;
}
</style>



// WEBPACK FOOTER //
// src/App.vue